import { render, staticRenderFns } from "./ClubForm.vue?vue&type=template&id=fd3580bc&scoped=true"
import script from "./ClubForm.vue?vue&type=script&lang=js"
export * from "./ClubForm.vue?vue&type=script&lang=js"
import style0 from "./ClubForm.vue?vue&type=style&index=0&id=fd3580bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3580bc",
  null
  
)

export default component.exports